import React, { Suspense } from 'react';
import { RouterProvider } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import router from './routes/Router';
import themeConfig from './theme/themeConfig';
import GlobalStyles from './theme/globalStyles';
import { SnackbarProvider } from './contexts/SnackbarContext/SnackbarProvider';

const App: React.FC = () => {
  return (
    <ConfigProvider theme={themeConfig}>
      <GlobalStyles />
      <SnackbarProvider>
        <Suspense fallback={<p>loading...</p>}>
          <RouterProvider router={router} />
        </Suspense>
      </SnackbarProvider>
    </ConfigProvider>
  );
};

export default App;
